import { Transition } from 'react-transition-group';
import { autoUpdate, size, useFloating } from '@floating-ui/react';
import { useMegaMenuStore } from './UseMegaMenuStore';

const MegaMenuContainer = ({ children, headerRef, ...props }) => {
  const { close, menuIsOpen } = useMegaMenuStore();

  const { refs, floatingStyles } = useFloating({
    elements: {
      reference: headerRef.current,
    },
    open: menuIsOpen,
    strategy: 'fixed',
    placement: 'bottom',
    middleware: [
      size({
        apply({ availableHeight, elements }) {
          Object.assign(elements.floating.style, {
            maxHeight: `${availableHeight}px`,
          });
        },
      }),
    ],
    whileElementsMounted: autoUpdate,
  });

  function handleBackdropClick() {
    close();
  }

  return (
    <Transition nodeRef={refs.floating} in={menuIsOpen} timeout={300}>
      {(state) => (
        <div
          {...props}
          ref={refs.setFloating}
          className={`overflow-hidden w-full z-40 bottom-0
                        before:bg-black/50 before:transition
                        ${state === 'exited' ? 'pointer-events-none' : ''}`}
          style={floatingStyles}
        >
          <div
            aria-hidden
            className={`absolute inset-0 bg-black/50 transition
                            ${state === 'entering' || state === 'entered' ? 'opacity-100 backdrop-blur-md' : ''}
                            ${state === 'exiting' || state === 'exited' ? 'opacity-0 backdrop-blur-none' : ''}
                        `}
            onClick={handleBackdropClick}
          />
          {children}
        </div>
      )}
    </Transition>
  );
};

export default MegaMenuContainer;
